import {
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  TextField,
} from '@mui/material';
import {
  Calendar,
  ChatText,
  EnvelopeSimple,
  PhoneCall,
} from '@phosphor-icons/react';
import { useState } from 'react';
import theme from '../../theme';

export const Scheduling = () => {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: '#F8F9FC',
        borderRadius: 2,
        border: '1px solid #E0E0E0',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, borderBottom: '1px solid #E0E0E0' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'custom.textBlue',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            fontWeight: 500,
            width: '100%',
          }}
        >
          <Calendar size={18} weight="bold" />
          Scheduling
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'lightGray.text',
            mb: 2,
            fontSize: '12px',
            fontWeight: 400,
            width: '100%',
          }}
        >
          Allow Quibble to manage your calendar: This feature lets Quibble
          create, modify, and delete appointments, syncing directly with your
          personal calendar.
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
          width: '100%',
        }}
      >
        <Typography
          variant="body2"
          sx={{ mb: 1, fontSize: '14px', width: '30%' }}
        >
          Link Your Calendar
        </Typography>
        <Select
          size="small"
          displayEmpty
          defaultValue=""
          sx={{
            height: '32px',
            width: '100%',
            '& .MuiSelect-select': {
              display: 'flex',
              padding: '4px 14px',
              alignItems: 'center',
              borderRadius: '6px',
              border: '1px solid #DCE0E7',
              background: '#F8F9FC',
              fontWeight: 400,
              lineHeight: 'normal',
              letterSpacing: '-0.14px',
              color: theme.palette.lightGray.text,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        >
          <MenuItem value="" disabled>
            Choose Provider
          </MenuItem>
          <MenuItem value="google">Google Calendar</MenuItem>
          <MenuItem value="outlook">Outlook Calendar</MenuItem>
          <MenuItem value="apple">Apple Calendar</MenuItem>
        </Select>

        <Button
          variant="contained"
          sx={{
            height: '32px',
            width: '30%',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            boxShadow: 'none',
            bgcolor: 'primary.main',
            color: 'white',
            '&:hover': { bgcolor: 'primary.dark' },
          }}
        >
          Link Calendar
        </Button>
      </Box>
    </Box>
  );
};

export const SendSMS = () => {
  const [smsContent, setSmsContent] = useState('');
  const [smsActionTime, setSmsActionTime] = useState('');
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: '#F8F9FC',
        borderRadius: 2,
        border: '1px solid #E0E0E0',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, borderBottom: '1px solid #E0E0E0' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'custom.textBlue',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            fontSize: '14px',
            fontWeight: 500,
            width: '100%',
          }}
        >
          <ChatText size={18} weight="bold" />
          Send SMS
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'lightGray.text',
            mb: 2,
            fontSize: '12px',
            fontWeight: 400,
            width: '100%',
          }}
        >
          Empower Quibble to effortlessly send SMS messages directly to your
          customers.
        </Typography>
      </Box>

      <Box sx={{ py: 2 }}>
        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          SMS Content
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={12}
          placeholder="Enter message to be sent here"
          value={smsContent}
          onChange={e => setSmsContent(e.target.value)}
          sx={{
            bgcolor: '#F8F9FC',
            fontSize: '14px',
            '& .MuiInputBase-input': { fontSize: '14px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#DCE0E7', borderRadius: '6px' },
            },
          }}
        />

        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mt: 2, mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          When to trigger action
        </Typography>
        <TextField
          fullWidth
          placeholder="eg., if the client agrees to receive a payment link"
          size="small"
          value={smsActionTime}
          onChange={e => setSmsActionTime(e.target.value)}
          sx={{
            bgcolor: '#F8F9FC',
            '& .MuiInputBase-input': { fontSize: '14px', height: '16px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#E0E0E0', borderRadius: '6px' },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export const SendEmail = () => {
  const [emailSubject, setEmailSubject] = useState('');
  const [emailContent, setEmailContent] = useState('');
  const [emailActionTime, setEmailActionTime] = useState('');
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: '#F8F9FC',
        borderRadius: 2,
        border: '1px solid #E0E0E0',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, borderBottom: '1px solid #E0E0E0' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'custom.textBlue',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            fontSize: '14px',
            fontWeight: 500,
            width: '100%',
          }}
        >
          <EnvelopeSimple size={18} weight="bold" />
          Send Email
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'lightGray.text',
            mb: 2,
            fontSize: '12px',
            fontWeight: 400,
            width: '100%',
          }}
        >
          Enable sending an email to your customers in real time during the
          conversation.
        </Typography>
      </Box>

      <Box sx={{ py: 2 }}>
        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          Subject
        </Typography>
        <TextField
          fullWidth
          placeholder="eg., if the client agrees to receive a payment link"
          size="small"
          value={emailSubject}
          onChange={e => setEmailSubject(e.target.value)}
          sx={{
            bgcolor: '#F8F9FC',
            '& .MuiInputBase-input': { fontSize: '14px', height: '16px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#E0E0E0', borderRadius: '6px' },
            },
          }}
        />

        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mt: 2, mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          Email Content
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={12}
          placeholder="Enter message to be sent here"
          value={emailContent}
          onChange={e => setEmailContent(e.target.value)}
          sx={{
            bgcolor: '#F8F9FC',
            fontSize: '14px',
            '& .MuiInputBase-input': { fontSize: '14px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#DCE0E7', borderRadius: '6px' },
            },
          }}
        />

        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mt: 2, mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          When to trigger action
        </Typography>
        <TextField
          fullWidth
          placeholder="eg., if the client agrees to receive a payment link"
          size="small"
          value={emailActionTime}
          onChange={e => setEmailActionTime(e.target.value)}
          sx={{
            bgcolor: '#F8F9FC',
            '& .MuiInputBase-input': { fontSize: '14px', height: '16px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#E0E0E0', borderRadius: '6px' },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export const TransferCall = () => {
  const [transferCallNumber, setTransferCallNumber] = useState('');
  const [transferCallActionTime, setTransferCallActionTime] = useState('');
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: '#F8F9FC',
        borderRadius: 2,
        border: '1px solid #E0E0E0',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, borderBottom: '1px solid #E0E0E0' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'custom.textBlue',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            fontSize: '14px',
            fontWeight: 500,
            width: '100%',
          }}
        >
          <PhoneCall size={16} />
          Transfer Call
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'lightGray.text',
            mb: 2,
            fontSize: '12px',
            fontWeight: 400,
            width: '100%',
          }}
        >
          Ensure Quibble can seamlessly transfer calls to the number of your
          choice whenever necessary.
        </Typography>
      </Box>

      <Box sx={{ py: 2 }}>
        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          Add Number to Transfer call to
        </Typography>
        <TextField
          fullWidth
          placeholder="Enter phone number"
          size="small"
          value={transferCallNumber}
          onChange={e => setTransferCallNumber(e.target.value)}
          InputProps={{
            startAdornment: (
              <Select
                value="+91"
                variant="standard"
                sx={{
                  '&:before': { border: 'none' },
                  '&:after': { border: 'none' },
                  '& .MuiSelect-select': {
                    display: 'flex',
                    py: 0,
                    alignItems: 'center',
                    borderRadius: '6px',
                    border: '1px solid #DCE0E7',
                    background: '#F8F9FC',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    letterSpacing: '-0.14px',
                    color: theme.palette.lightGray.text,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                }}
              >
                <MenuItem value="+91">+91</MenuItem>
              </Select>
            ),
          }}
          sx={{
            bgcolor: '#F8F9FC',
            '& .MuiInputBase-input': { fontSize: '14px', height: '16px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#E0E0E0', borderRadius: '6px' },
            },
          }}
        />

        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mt: 2, mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          When to trigger action
        </Typography>
        <TextField
          fullWidth
          placeholder="eg., if the client agrees to receive a payment link"
          size="small"
          value={transferCallActionTime}
          onChange={e => setTransferCallActionTime(e.target.value)}
          sx={{
            bgcolor: '#F8F9FC',
            '& .MuiInputBase-input': { fontSize: '14px', height: '16px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#E0E0E0', borderRadius: '6px' },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export const TakingMessage = () => {
  const [email, setEmail] = useState('');
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: '#F8F9FC',
        borderRadius: 2,
        border: '1px solid #E0E0E0',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, borderBottom: '1px solid #E0E0E0' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'custom.textBlue',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            fontSize: '14px',
            fontWeight: 500,
            width: '100%',
          }}
        >
          <ChatText size={18} weight="bold" />
          Taking Message
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'lightGray.text',
            mb: 2,
            fontSize: '12px',
            fontWeight: 400,
            width: '100%',
          }}
        >
          Quibble can take messages from your customers and send them to your
          email or multiple emails that you provide.
        </Typography>
      </Box>

      <Box sx={{ py: 2 }}>
        <Typography
          variant="body2"
          color="custom.textBlue"
          sx={{ mb: 1, fontSize: '12px', fontWeight: 500 }}
        >
          Emails
        </Typography>
        <TextField
          fullWidth
          placeholder="abc@example.com"
          size="small"
          value={email}
          onChange={e => setEmail(e.target.value)}
          sx={{
            bgcolor: '#F8F9FC',
            '& .MuiInputBase-input': { fontSize: '14px', height: '16px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#E0E0E0', borderRadius: '6px' },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export const API = () => {
  const [activeTab, setActiveTab] = useState('headers');
  const [activeMethod, setActiveMethod] = useState('GET');
  const [apiRoute, setApiRoute] = useState('');
  const [headers, setHeaders] = useState({ key: '', value: '' });
  const [body, setBody] = useState('');

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: '#F8F9FC',
        borderRadius: 2,
        border: '1px solid #E0E0E0',
        backgroundColor: 'white',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, borderBottom: '1px solid #E0E0E0' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'custom.textBlue',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            fontSize: '14px',
            fontWeight: 500,
            width: '100%',
          }}
        >
          API
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'lightGray.text',
            mb: 2,
            fontSize: '12px',
            fontWeight: 400,
            width: '100%',
          }}
        >
          Access any API endpoint during the conversation to post or retrieve
          real-time information effortlessly.
        </Typography>
      </Box>

      <Box sx={{ py: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Select
            size="small"
            defaultValue="GET"
            sx={{
              width: '100px',
              bgcolor: 'white',
              height: '36px',
              '& .MuiSelect-select': {
                display: 'flex',
                padding: '4px 14px',
                alignItems: 'center',
                borderRadius: '6px',
                border: '1px solid #DCE0E7',
                background: '#F8F9FC',
                fontWeight: 400,
                lineHeight: 'normal',
                letterSpacing: '-0.14px',
                color: theme.palette.lightGray.text,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
            }}
            value={activeMethod}
            onChange={e => setActiveMethod(e.target.value)}
          >
            <MenuItem value="GET">GET</MenuItem>
            <MenuItem value="POST">POST</MenuItem>
            <MenuItem value="PUT">PUT</MenuItem>
            <MenuItem value="DELETE">DELETE</MenuItem>
          </Select>

          <TextField
            fullWidth
            placeholder="API Route"
            size="small"
            sx={{
              bgcolor: 'white',
              '& .MuiInputBase-input': { fontSize: '14px' },
            }}
            value={apiRoute}
            onChange={e => setApiRoute(e.target.value)}
          />

          <Button
            variant="contained"
            sx={{
              bgcolor: '#E8EAF6',
              color: '#000',
              height: '36px',
              '&:hover': { bgcolor: '#C5CAE9' },
              textTransform: 'none',
              fontSize: '14px',
              boxShadow: 'none',
              px: 3,
            }}
          >
            Save
          </Button>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
            <Button
              variant="text"
              onClick={() => setActiveTab('headers')}
              sx={{
                color: activeTab === 'headers' ? 'primary.main' : '#000',
                textTransform: 'none',
                fontSize: '14px',
                borderBottom: activeTab === 'headers' ? '2px solid' : 'none',
                borderRadius: 0,
                '&:hover': {
                  bgcolor: 'transparent',
                  textDecoration: 'underline',
                },
              }}
            >
              Headers
            </Button>
            <Button
              variant="text"
              onClick={() => setActiveTab('body')}
              sx={{
                color: activeTab === 'body' ? 'primary.main' : '#000',
                textTransform: 'none',
                fontSize: '14px',
                borderBottom: activeTab === 'body' ? '2px solid' : 'none',
                borderRadius: 0,
                '&:hover': {
                  bgcolor: 'transparent',
                  textDecoration: 'underline',
                },
              }}
            >
              Body
            </Button>
          </Box>

          {activeTab === 'headers' ? (
            <Box
              sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}
            >
              <Box>
                <Typography variant="body2" sx={{ mb: 1, fontSize: '14px' }}>
                  Key
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Placeholder"
                  size="small"
                  sx={{
                    mb: 2,
                    bgcolor: 'white',
                    '& .MuiInputBase-input': { fontSize: '14px' },
                  }}
                  value={headers.key}
                  onChange={e =>
                    setHeaders({ ...headers, key: e.target.value })
                  }
                />
                <TextField
                  fullWidth
                  placeholder="Placeholder"
                  size="small"
                  sx={{
                    bgcolor: 'white',
                    '& .MuiInputBase-input': { fontSize: '14px' },
                  }}
                  value={headers.key}
                  onChange={e =>
                    setHeaders({ ...headers, key: e.target.value })
                  }
                />
              </Box>
              <Box>
                <Typography variant="body2" sx={{ mb: 1, fontSize: '14px' }}>
                  Value
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Placeholder"
                  size="small"
                  sx={{
                    mb: 2,
                    bgcolor: 'white',
                    '& .MuiInputBase-input': { fontSize: '14px' },
                  }}
                  value={headers.value}
                  onChange={e =>
                    setHeaders({ ...headers, value: e.target.value })
                  }
                />
                <TextField
                  fullWidth
                  placeholder="Placeholder"
                  size="small"
                  sx={{
                    bgcolor: 'white',
                    '& .MuiInputBase-input': { fontSize: '14px' },
                  }}
                  value={headers.value}
                  onChange={e =>
                    setHeaders({ ...headers, value: e.target.value })
                  }
                />
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                mt: 2,
                border: '5px solid #F3F5F8',
                borderRadius: '8px',
                bgcolor: 'white',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  fontSize: '14px',
                  py: 1,
                  px: 2,
                  borderBottom: '2px solid #F3F5F8',
                  bgcolor: '#F3F5F8',
                }}
              >
                Body Code
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={12}
                placeholder="Enter body code here"
                value={body}
                onChange={e => setBody(e.target.value)}
                sx={{
                  bgcolor: 'white',
                  '& .MuiInputBase-input': { fontSize: '14px' },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { border: 'none', outline: 'none' },
                  },
                }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
